import { render, staticRenderFns } from "./AddUpdateMessageTemplates.vue?vue&type=template&id=3e7fb2ea&scoped=true"
import script from "./AddUpdateMessageTemplates.vue?vue&type=script&lang=js"
export * from "./AddUpdateMessageTemplates.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e7fb2ea",
  null
  
)

export default component.exports